module.exports = __webpack_public_path__ + "img/balance.8753329f.png";